import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { FEATURED } from "@/data/featuredMcDonalds";

export function FeaturedFigures() {
  const { t } = useLanguage();

  return (
    <section data-testid="featured-figures" className="mt-16">
      <span className="inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] text-clan-accent">
        {t.notable.featured}
      </span>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURED.map((f, i) => (
          <motion.article
            key={f.name}
            data-testid={`featured-card-${i}`}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
            className="group flex items-center gap-5 overflow-hidden rounded-lg border border-clan-ink/10 bg-clan-surface p-5 transition-colors duration-300 hover:border-clan-accent/40"
          >
            <div className="relative shrink-0">
              <img
                src={f.emblem}
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="h-20 w-20 rounded-md border border-clan-gold/40 object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-clan-accent">{f.role}</span>
              <p className="mt-1 font-serif text-xl leading-snug text-clan-ink">
                {f.name}
                {f.life && <span className="ml-2 font-mono text-xs tracking-wide text-clan-muted">{f.life}</span>}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-clan-muted">{f.note}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
